(() => {
  "use strict";

  if (window.eyeCandyCollectionCompareLoaded) return;
  window.eyeCandyCollectionCompareLoaded = true;

  const STORAGE_KEY = "eyeCandyCompareHandles";
  const config = document.querySelector("[data-eye-candy-collection-compare]");
  if (!config) return;

  const compareUrl = config.dataset.compareUrl || "/pages/compare-pigments";
  const buttonLabel = config.dataset.buttonLabel || "Compare";
  const selectedLabel = config.dataset.selectedLabel || "Added to compare";
  const maxProducts = Number(config.dataset.maxProducts) || 30;

  function readHandles() {
    try {
      const handles = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || "[]");
      return Array.isArray(handles) ? handles.filter((handle) => typeof handle === "string").slice(0, maxProducts) : [];
    } catch {
      return [];
    }
  }

  function writeHandles(handles) {
    const next = [...new Set(handles)].slice(0, maxProducts);
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
    window.dispatchEvent(new CustomEvent("eye-candy:compare-updated", { detail: { handles: next } }));
    return next;
  }

  function productHandleFromCard(card) {
    const link = card.querySelector('a[href*="/products/"]');
    if (!link) return "";
    const match = link.getAttribute("href")?.match(/\/products\/([^/?#]+)/);
    return match ? decodeURIComponent(match[1]) : "";
  }

  function getActionContainer(card) {
    let actions = card.querySelector(".ec-card-actions");
    if (actions) return actions;

    actions = document.createElement("div");
    actions.className = "ec-card-actions";
    const cardInfo = card.querySelector(".card-info") || card;
    const price = cardInfo.querySelector(".x-card-price");
    if (price) price.insertAdjacentElement("afterend", actions);
    else cardInfo.append(actions);
    return actions;
  }

  function showMessage(message) {
    let messageNode = document.querySelector(".ec-collection-compare-message");
    if (!messageNode) {
      messageNode = document.createElement("div");
      messageNode.className = "ec-collection-compare-message";
      messageNode.setAttribute("role", "status");
      document.body.append(messageNode);
    }
    messageNode.textContent = message;
    messageNode.classList.add("is-visible");
    window.clearTimeout(showMessage.timeoutId);
    showMessage.timeoutId = window.setTimeout(() => messageNode.classList.remove("is-visible"), 2400);
  }

  function updateInterface() {
    const handles = readHandles();
    document.querySelectorAll(".ec-card-compare-button[data-product-handle]").forEach((button) => {
      const selected = handles.includes(button.dataset.productHandle);
      button.setAttribute("aria-pressed", String(selected));
      button.textContent = selected ? selectedLabel : buttonLabel;
    });

    let tray = document.querySelector(".ec-collection-compare-tray");
    if (!handles.length) {
      tray?.remove();
      return;
    }

    if (!tray) {
      tray = document.createElement("aside");
      tray.className = "ec-collection-compare-tray";
      tray.setAttribute("aria-label", "Selected comparison products");
      tray.innerHTML = `
        <div class="ec-collection-compare-popout">
          <div class="ec-collection-compare-popout__panel" id="ec-compare-panel" hidden>
            <div class="ec-collection-compare-popout__summary">
              <span>Ready to compare?</span>
              <div class="ec-collection-compare-popout__selection">
                <strong class="ec-collection-compare-popout__selected"></strong>
                <button class="ec-collection-compare-popout__clear" type="button">Clear all</button>
              </div>
            </div>
            <a class="ec-collection-compare-popout__link">View comparison</a>
          </div>
          <button class="ec-collection-compare-popout__toggle" type="button" aria-expanded="false" aria-controls="ec-compare-panel">
            <span>Compare</span>
            <strong class="ec-collection-compare-popout__count"></strong>
          </button>
        </div>`;
      tray.querySelector(".ec-collection-compare-popout__clear").addEventListener("click", () => {
        writeHandles([]);
        updateInterface();
      });
      const popoutToggle = tray.querySelector(".ec-collection-compare-popout__toggle");
      const popoutPanel = tray.querySelector(".ec-collection-compare-popout__panel");
      popoutToggle.addEventListener("click", () => {
        const willOpen = popoutToggle.getAttribute("aria-expanded") !== "true";
        popoutToggle.setAttribute("aria-expanded", String(willOpen));
        popoutPanel.hidden = !willOpen;
        tray.querySelector(".ec-collection-compare-popout").classList.toggle("is-open", willOpen);
      });
      document.body.append(tray);
    }

    tray.querySelector(".ec-collection-compare-popout__count").textContent = handles.length;
    tray.querySelector(".ec-collection-compare-popout__selected").textContent = `${handles.length} of ${maxProducts} selected`;
    const link = tray.querySelector(".ec-collection-compare-popout__link");
    const target = new URL(compareUrl, window.location.origin);
    target.searchParams.set("compare", handles.join(","));
    target.hash = "comparison";
    link.href = target.toString();
  }

  function toggleHandle(handle) {
    const handles = readHandles();
    const index = handles.indexOf(handle);
    if (index >= 0) {
      handles.splice(index, 1);
    } else if (handles.length < maxProducts) {
      handles.push(handle);
    } else {
      showMessage(`You can compare up to ${maxProducts} products. Remove one before adding another.`);
      return;
    }
    writeHandles(handles);
    updateInterface();
  }

  function injectButtons() {
    document.querySelectorAll(".card-product").forEach((card) => {
      if (card.querySelector(".ec-card-compare-button")) return;
      const handle = productHandleFromCard(card);
      if (!handle) return;

      const button = document.createElement("button");
      button.className = "ec-card-compare-button";
      button.type = "button";
      button.dataset.productHandle = handle;
      button.addEventListener("click", (event) => {
        event.preventDefault();
        event.stopPropagation();
        toggleHandle(handle);
      });

      getActionContainer(card).append(button);
    });
    updateInterface();
  }

  let scanQueued = false;
  const queueScan = () => {
    if (scanQueued) return;
    scanQueued = true;
    window.requestAnimationFrame(() => {
      scanQueued = false;
      injectButtons();
    });
  };

  const observer = new MutationObserver(queueScan);
  observer.observe(document.body, { childList: true, subtree: true });
  window.addEventListener("storage", updateInterface);
  window.addEventListener("eye-candy:compare-updated", updateInterface);
  injectButtons();
})();
